// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Breach Contributors

import { Routes, Route } from 'react-router-dom';
import Sidebar from '@/components/layout/Sidebar';
import Home from '@/routes/Home';
import Settings from '@/routes/Settings';

export default function App() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-breach-900 text-breach-100">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/settings/*" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}
